import { APP_LANGUAGE } from 'commons/models/common';

export type TContentTranslationInput = {
	[key in APP_LANGUAGE]: string;
};
export interface ISpotlightUserStats {
	type: string;
	value: TContentTranslationInput;
}

export enum EContentType {
	SPOTLIGHT = 'spotlight',
	STORY = 'story'
}

export enum ESpotlightTagType {
	WINNINGS = 'winnings',
	CUSTOM = 'custom'
}

export enum EContentViewCardsType {
	LOCATION = 'LOCATION',
	OCCUPATION = 'OCCUPATION',
	GAMES_WON = 'GAMES_WON',
	FAVORITE_GAME = 'FAVORITE_GAME',
	PLAYING_SINCE = 'PLAYING_SINCE'
}

export const STAT_TYPES = [
	{ id: null, label: 'Nil' },
	{ id: EContentViewCardsType.OCCUPATION, label: EContentViewCardsType.OCCUPATION },
	{ id: EContentViewCardsType.FAVORITE_GAME, label: EContentViewCardsType.FAVORITE_GAME },
	{ id: EContentViewCardsType.LOCATION, label: EContentViewCardsType.LOCATION }
];

export const TAG_TYPES = [
	{ id: null, label: 'Nil' },
	{ id: ESpotlightTagType.WINNINGS, label: ESpotlightTagType.WINNINGS },
	{ id: ESpotlightTagType.CUSTOM, label: ESpotlightTagType.CUSTOM }
];

export type TSubmitSpotlightData = {
	id?: string;
	zupeeUserId: number;
	displayNameEn: string;
	displayNameHi: string;
	displayNameMr: string;
	userStats: {
		statsType: string;
		statsValueEn: string;
		statsValueHi: string;
		statsValueMr: string;
	}[];
	statsType?: string;
	statsValueEn?: string;
	statsValueHi?: string;
	statsValueMr?: string;
	liveSince: number;
	liveTill: number;
	archiveTime?: number;
	createdAt: number;
	updatedAt: number;
	viewCount: number;
	durationInSec: number;
	thumbnailUrl: string;
	videoUrl: string;
	shareUrl?: string;
	tagInfoType: string;
	tagInfoTitleEn?: string;
	tagInfoTitleHi?: string;
	tagInfoTitleMr?: string;
	tagInfoDescEn?: string;
	tagInfoDescHi?: string;
	tagInfoDescMr?: string;
};

export type TSpotlightData = {
	_id?: string;
	data: {
		durationInSec: number;
		thumbnailUrl: string;
		videoUrl: string;
		shareUrl?: string;
	};
	liveSince: number;
	liveTill: number;
	archiveTime?: number;
	userStats: ISpotlightUserStats[];
	userData: {
		zupeeUserId: number;
		displayName: {
			en: string;
			hi: string;
			mr: string;
		};
	};
	viewCount: {
		value: number;
		lastUpdated?: {
			date: number;
			time: string;
		};
	};
	reactions?: [any];
	createdAt: number;
	updatedAt: number;
	index?: number;
	tagInfo: {
		type: string;
		title?: {
			en: string;
			hi: string;
			mr: string;
		};
		description?: {
			en: string;
			hi: string;
			mr: string;
		};
	};
};
